<script>
import ContentCard from './Content'

export default {
  name: 'DynamicContent',

  extends: ContentCard
}
</script>



// WEBPACK FOOTER //
// DynamicContent.vue?1d2642f5